module.exports = __webpack_public_path__ + "assets/media/day26.37afd83f.mp3";